import React from "react";
import Pagination from "../Pagination";
import { server } from "../../../utilis/constant";

const ProductTable = ({
  data,
  currentPage,
  totalPages,
  itemsPerPage = 10,
  onPageChange,
  onView,
  onDelete,
  onEdit,
}) => {
  return (
    <div className="w-full">
      {/* TABLE WRAPPER */}
      <div className="overflow-x-auto rounded-2xl border border-white/10 bg-[#0f0f14] shadow-xl">
        <table className="min-w-full text-white">
          {/* HEADER */}
          <thead className="bg-white/5 text-gray-300 text-sm uppercase tracking-wide">
            <tr>
              <th className="px-4 py-4 text-left">#</th>
              <th className="px-4 py-4 text-left">Product</th>
              <th className="px-4 py-4 text-left">Price</th>
              <th className="px-4 py-4 text-left">Type</th>
              <th className="px-4 py-4 text-left">Status</th>
              <th className="px-4 py-4 text-center">Actions</th>
            </tr>
          </thead>

          {/* BODY */}
          <tbody>
            {data && data.length > 0 ? (
              data.map((item, index) => (
                <tr
                  key={index}
                  className="border-t border-white/5 hover:bg-white/5 transition group"
                >
                  {/* INDEX */}
                  <td className="px-4 py-4 text-gray-400 text-sm">
                    {(currentPage - 1) * itemsPerPage + index + 1}
                  </td>

                  {/* PRODUCT INFO */}
                  <td className="px-4 py-4 flex items-center gap-3">
                    <img
                      src={`${server}/${item.image}`}
                      alt=""
                      className="w-12 h-12 rounded-lg object-cover border border-white/10"
                    />

                    <div className="flex flex-col">
                      <span className="text-sm font-medium group-hover:text-white">
                        {item.title}
                      </span>
                      <span className="text-xs text-gray-400">
                        {item.vendor}
                      </span>
                    </div>
                  </td>

                  {/* PRICE */}
                  <td className="px-4 py-4 text-sm text-gray-300">
                    ${item.price || "0"}
                  </td>

                  {/* TYPE */}
                  <td className="px-4 py-4 text-sm text-gray-300">
                    {item.type}
                  </td>

                  {/* STATUS */}
                  <td className="px-4 py-4">
                    <span
                      className={`px-3 py-1 rounded-full text-xs font-medium
                  ${
                    item.sku
                      ? "bg-green-500/10 text-green-400"
                      : "bg-yellow-500/10 text-yellow-400"
                  }`}
                    >
                      {item.sku ? "Active" : "Pending"}
                    </span>
                  </td>

                  {/* ACTIONS */}
                  <td className="px-4 py-4">
                    <div className="flex justify-center gap-2">
                      <button
                        onClick={() => onView(item)}
                        className="px-3 py-1.5 text-xs rounded-lg bg-green-500/10 text-green-400 hover:bg-green-500/20 transition"
                      >
                        View
                      </button>

                      <button
                        onClick={() => onEdit(item)}
                        className="px-3 py-1.5 text-xs rounded-lg bg-blue-500/10 text-blue-400 hover:bg-blue-500/20 transition"
                      >
                        Edit
                      </button>

                      <button
                        onClick={() => onDelete(item._id)}
                        className="px-3 py-1.5 text-xs rounded-lg bg-red-500/10 text-red-400 hover:bg-red-500/20 transition"
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={6}
                  className="text-center py-10 text-gray-400 text-sm"
                >
                  No products found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* PAGINATION */}
      <div className="mt-5 flex justify-center">
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={onPageChange}
        />
      </div>
    </div>
  );
};

export default ProductTable;
